import { render } from "./AlertModal.vue?vue&type=template&id=1618625e"
import script from "./AlertModal.vue?vue&type=script&lang=js"
export * from "./AlertModal.vue?vue&type=script&lang=js"

import "./AlertModal.vue?vue&type=style&index=0&id=1618625e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__